import { render } from "./SearchOptimalSuggest.vue?vue&type=template&id=2a785958&scoped=true"
import script from "./SearchOptimalSuggest.vue?vue&type=script&lang=js"
export * from "./SearchOptimalSuggest.vue?vue&type=script&lang=js"

import "./SearchOptimalSuggest.vue?vue&type=style&index=0&id=2a785958&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a785958"]])

export default __exports__